import { render, staticRenderFns } from "./CarouselPanel.vue?vue&type=template&id=e4ec8b5e&scoped=true&"
import script from "./CarouselPanel.vue?vue&type=script&lang=js&"
export * from "./CarouselPanel.vue?vue&type=script&lang=js&"
import style0 from "./CarouselPanel.vue?vue&type=style&index=0&id=e4ec8b5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ec8b5e",
  null
  
)

export default component.exports